import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { equalisations as rules } from 'further-ui/validations';
import { z } from 'zod';

export type EqualisationInterestFormValues = z.infer<
  typeof rules.UpdateEqualisationInterestFormSchema
>;

type Props = {
  values: EqualisationInterestFormValues;
  children: React.ReactNode;
};

const FormWrapper: React.FC<Props> = ({ children, values }) => {
  const formMethods = useForm<EqualisationInterestFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(rules.UpdateEqualisationInterestFormSchema),
    defaultValues: values,
    criteriaMode: 'all',
    reValidateMode: 'onChange',
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
